export default __webpack_public_path__ + "static/discovery-visibility-c4604958f048edb260805d59df1cb03e.jpg";